export default {
  addComment: { id: 'add_comment' },
  logbookForms: { id: 'logbook_forms' },
  logbookFormsTitle: { id: 'logbook_forms' },
  logbookBreadcrumbsTitle: { id: 'logbook_breadcrumbs' },
  siteList: { id: 'site' },
  attachmentFile: { id: 'attachment_file' },
  uploadPdfPngJpg: { id: 'upload_Pdf_Png_Jpg' },
  fileNotUploadMessage: { id: 'file_not_upload_message' },
  deleteFileConfirmMessage: { id: 'are_you_sure_you_want_to_delete_this_file' },
  cancel: { id: 'cancel' },
  delete: { id: 'delete' },
}
